// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__21nMp"};